<template>
<b-tabs card>
  <b-tab title="Информация">
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-form-group
            label="Название:"
            :invalid-feedback="errors.name"
            :state="states.name"
          >
            <b-form-input
              type="text"
              size="sm"
              autofocus
              :value="item.name"
              :state="states.name"
              :disabled="loading"
              @change="updateValue('name', $event)"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Название (eng):"
              :invalid-feedback="errors.nameEn"
              :state="states.nameEn"
          >
            <b-form-input
                type="text"
                size="sm"
                :value="item.nameEn"
                :state="states.nameEn"
                :disabled="loading"
                @change="updateValue('nameEn', $event)"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
              label="Длительность:"
              :invalid-feedback="errors.duration"
              :state="states.duration"
          >
            <b-form-input
                type="number"
                size="sm"
                :value="item.duration"
                :state="states.duration"
                :disabled="loading"
                @change="updateValue('duration', $event)"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Полная Длительность:"
              :invalid-feedback="errors.durationTotal"
              :state="states.durationTotal"
          >
            <b-form-input
                type="number"
                size="sm"
                :value="item.durationTotal"
                :state="states.durationTotal"
                :disabled="loading"
                @change="updateValue('durationTotal', $event)"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Подтверждено:"
              :invalid-feedback="errors.durationApproved"
              :state="states.durationApproved"
          >
            <b-form-checkbox
                :checked="item.durationApproved"
                :state="states.durationApproved"
                :disabled="loading"
                @change="updateValue('durationApproved', !item.durationApproved)"
            >
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
              label="Отечественный фильм:"
              :invalid-feedback="errors.russian"
              :state="states.russian"
          >
            <b-form-checkbox
                :checked="item.russian"
                :state="states.russian"
                :disabled="loading"
                @change="updateValue('russian', !item.russian)"
            >
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Есть прокат в России:"
              :invalid-feedback="errors.russianRental"
              :state="states.russianRental"
          >
            <b-form-checkbox
                :checked="item.russianRental"
                :state="states.russianRental"
                :disabled="loading"
                @change="updateValue('russianRental', !item.russianRental)"
            >
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Количество копий:"
              :invalid-feedback="errors.copies"
              :state="states.copies"
          >
            <b-form-input
                type="number"
                size="sm"
                :value="item.copies"
                :state="states.copies"
                :disabled="loading"
                @change="updateValue('copies', $event)"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
              label="Дистрибьютор:"
              :invalid-feedback="errors.distributors"
              :state="states.distributors"
          >
            <dictionary-provider name="distributors">
              <template #default="{ items: distributors, loading: distributorsLoading }">
                <toggle-list
                  :options="distributors"
                  :value="item.distributorId ? [convertToValue(item.distributorId, distributors)] : []"
                  :searchable="true"
                  :disabled="loading || distributorsLoading"
                  :multiple="false"
                  :close-on-select="true"
                  @change="updateDistributorId($event)"
                ></toggle-list>
              </template>
            </dictionary-provider>
          </b-form-group>
        </b-col>
      </b-row>
      
      <b-row>
        <b-col>
          <b-form-group
            label="Доставка:"
            :invalid-feedback="errors.laboratory"
            :state="states.laboratory"
          >
            <dictionary-provider name="laboratories">
              <template #default="{ items: laboratories, loading: laboratoriesLoading }">
                <toggle-list
                  :options="laboratoriesWithDisplayName(laboratories)"
                  :value="getCurrentLaboratoryValue(laboratories)"
                  :searchable="true"
                  :disabled="loading || laboratoriesLoading"
                  :multiple="false"
                  :close-on-select="true"
                  @change="updateLaboratoryId($event)"
                ></toggle-list>
              </template>
            </dictionary-provider>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Ключ:"
            :invalid-feedback="errors.laboratoryKey"
            :state="states.laboratoryKey"
          >
            <b-form-input
              type="text"
              size="sm"
              :value="item.laboratoryKey"
              :state="states.laboratoryKey"
              :disabled="loading"
              @change="updateValue('laboratoryKey', $event)"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      
      <b-row>
        <b-col>
          <b-form-group
              label="Год:"
              :invalid-feedback="errors.year"
              :state="states.year"
          >
            <b-form-input
                type="text"
                size="sm"
                :value="item.year"
                :state="states.year"
                :disabled="loading"
                @change="updateValue('year', $event)"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Возрастное ограничение:"
              :invalid-feedback="errors.ageLimit"
              :state="states.ageLimit"
          >
            <dictionary-provider name="ageLimits">
              <template #default="{ items }">
                <b-select
                    size="sm"
                    :options="$array.convertToOptions(items)"
                    :value="item.ageLimit"
                    :state="states.ageLimit"
                    :disabled="loading"
                    @change="updateValue('ageLimit', $event)"
                ></b-select>
              </template>
            </dictionary-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            label="Описание:"
            :invalid-feedback="errors.description"
            :state="states.description"
          >
            <b-form-textarea
              type="text"
              size="sm"
              rows="10"
              :value="item.description"
              :state="states.description"
              :disabled="loading"
              @change="updateValue('description', $event)"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            label="Режиссеры:"
            :invalid-feedback="errors.directors"
            :state="states.directors"
          >
            <b-form-input
              type="text"
              size="sm"
              :value="item.directors"
              :state="states.directors"
              :disabled="loading"
              @change="updateValue('directors', $event)"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            label="Актеры:"
            :invalid-feedback="errors.actors"
            :state="states.actors"
          >
            <b-form-textarea
              type="text"
              size="sm"
              :value="item.actors"
              :state="states.actors"
              :disabled="loading"
              @change="updateValue('actors', $event)"
              rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            label="Жанры:"
            :invalid-feedback="errors.genres"
            :state="states.genres"
          >
            <dictionary-provider name="genres">
              <template #default="{ items }">
                <toggle-list
                  :options="items"
                  :value="item.genres"
                  :disabled="loading"
                  :searchable="true"
                  @change="updateValue('genres', $event)"
                ></toggle-list>
              </template>
            </dictionary-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            label="Страны:"
            :invalid-feedback="errors.countries"
            :state="states.countries"
          >
            <dictionary-provider name="countries">
              <template #default="{ items }">
                <toggle-list
                  :options="items"
                  :value="item.countries"
                  :disabled="loading"
                  :searchable="true"
                  @change="updateValue('countries', $event)"
                ></toggle-list>
              </template>
            </dictionary-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
              label="Старт проката в России:"
              :invalid-feedback="errors.dateStart"
              :state="states.dateStart"
          >
            <date
                size="sm"
                :value="item.dateStart"
                :state="states.dateStart"
                :disabled="loading"
                @selected="updateValue('dateStart', $event)"
            ></date>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Конец проката в России:"
              :invalid-feedback="errors.dateEnd"
              :state="states.dateEnd"
          >
            <date
                size="sm"
                :value="item.dateEnd"
                :state="states.dateEnd"
                :disabled="loading"
                @selected="updateValue('dateEnd', $event)"
            ></date>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Предпоказ в России:"
              :invalid-feedback="errors.datePreview"
              :state="states.datePreview"
          >
            <date
                size="sm"
                :value="item.datePreview"
                :state="states.datePreview"
                :disabled="loading"
                @selected="updateValue('datePreview', $event)"
            ></date>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
              label="Старт проката в мире:"
              :invalid-feedback="errors.worldDateStart"
              :state="states.worldDateStart"
          >
            <date
                size="sm"
                :value="item.worldDateStart"
                :state="states.worldDateStart"
                :disabled="loading"
                @selected="updateValue('worldDateStart', $event)"
            ></date>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Конец проката в мире:"
              :invalid-feedback="errors.worldDateEnd"
              :state="states.worldDateEnd"
          >
            <date
                size="sm"
                :value="item.worldDateEnd"
                :state="states.worldDateEnd"
                :disabled="loading"
                @selected="updateValue('worldDateEnd', $event)"
            ></date>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Предпоказ в мире:"
              :invalid-feedback="errors.worldDatePreview"
              :state="states.worldDatePreview"
          >
            <date
                size="sm"
                :value="item.worldDatePreview"
                :state="states.worldDatePreview"
                :disabled="loading"
                @selected="updateValue('worldDatePreview', $event)"
            ></date>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Номер прокатного удостоверения:"
            :invalid-feedback="errors.rentalLicenseNumber"
            :state="states.rentalLicenseNumber"
          >
            <b-form-input
              type="text"
              size="sm"
              :value="item.rentalLicenseNumber"
              :state="states.rentalLicenseNumber"
              :disabled="loading"
              @change="updateValue('rentalLicenseNumber', $event)"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Начало действия прокатного удостоверения:"
              :invalid-feedback="errors.rentalLicensePeriodStart"
              :state="states.rentalLicensePeriodStart"
          >
            <date
                size="sm"
                :value="item.rentalLicensePeriodStart"
                :state="states.rentalLicensePeriodStart"
                :disabled="loading"
                @selected="updateValue('rentalLicensePeriodStart', $event)"
            ></date>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Конец действия прокатного удостоверения:"
              :invalid-feedback="errors.rentalLicensePeriodEnd"
              :state="states.rentalLicensePeriodEnd"
          >
            <date
                size="sm"
                :value="item.rentalLicensePeriodEnd"
                :state="states.rentalLicensePeriodEnd"
                :disabled="loading"
                @selected="updateValue('rentalLicensePeriodEnd', $event)"
            ></date>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
              label="Прокатное удостоверение:"
              :invalid-feedback="errors.rentalLicensePath"
              :state="states.rentalLicensePath"
          >
            <b-row class="p-0">
              <b-col>
                <file-uploader
                    ref="fileUploader"
                    :accept="mimeTypes.join(',')"
                    :disabled="loading"
                    @change="uploadRentalLicenseFile($event)"
                ></file-uploader>
                <b-link target="_blank" v-if="item.rentalLicensePath" :href="item.rentalLicenseUrl">{{ item.rentalLicensePath.split('/').slice(-1)[0] }}</b-link>
              </b-col>

              <b-col>
                <div
                    v-if="!item.rentalLicensePath && !$fileManager2.files[rentalLicenseFileId]"
                    class="text-center"
                >
                </div>
                <div
                    v-if="!item.rentalLicensePath && $fileManager2.files[rentalLicenseFileId]"
                    class="loader"
                >
                  <template v-if="!$fileManager2.files[rentalLicenseFileId].error"><span class="mr-2">{{ $fileManager2.files[rentalLicenseFileId].progress }}%</span> <b-spinner variant="primary"></b-spinner></template>
                  <template v-else>Ошибка при загрузке файла!</template>
                </div>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Номер удостоверения национального фильма:"
            :invalid-feedback="errors.unfNumber"
            :state="states.unfNumber"
          >
            <b-form-input
              type="text"
              size="sm"
              :value="item.unfNumber"
              :state="states.unfNumber"
              :disabled="loading"
              @change="updateValue('unfNumber', $event)"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Начало действия удостоверения национального фильма:"
              :invalid-feedback="errors.unfPeriodStart"
              :state="states.unfPeriodStart"
          >
            <date
                size="sm"
                :value="item.unfPeriodStart"
                :state="states.unfPeriodStart"
                :disabled="loading"
                @selected="updateValue('unfPeriodStart', $event)"
            ></date>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Конец действия удостоверения национального фильма:"
              :invalid-feedback="errors.unfPeriodEnd"
              :state="states.unfPeriodEnd"
          >
            <date
                size="sm"
                :value="item.unfPeriodEnd"
                :state="states.unfPeriodEnd"
                :disabled="loading"
                @selected="updateValue('unfPeriodEnd', $event)"
            ></date>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
              label="Удостоверение национального фильма:"
              :invalid-feedback="errors.unfPath"
              :state="states.unfPath"
          >
            <b-row class="p-0">
              <b-col>
                <file-uploader
                    ref="fileUploader"
                    :accept="mimeTypes.join(',')"
                    :disabled="loading"
                    @change="uploadUnfFile($event)"
                ></file-uploader>
                <b-link target="_blank" v-if="item.unfPath" :href="item.unfUrl">{{ item.unfPath.split('/').slice(-1)[0] }}</b-link>
              </b-col>

              <b-col>
                <div
                    v-if="!item.unfPath && !$fileManager2.files[unfFileId]"
                    class="text-center"
                >
                </div>
                <div
                    v-if="!item.unfPath && $fileManager2.files[unfFileId]"
                    class="loader"
                >
                  <template v-if="!$fileManager2.files[unfFileId].error"><span class="mr-2">{{ $fileManager2.files[unfFileId].progress }}%</span> <b-spinner variant="primary"></b-spinner></template>
                  <template v-else>Ошибка при загрузке файла!</template>
                </div>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
              label="Начало действия меморандума:"
              :invalid-feedback="errors.memorandumPeriodStart"
              :state="states.memorandumPeriodStart"
          >
            <date
                size="sm"
                :value="item.memorandumPeriodStart"
                :state="states.memorandumPeriodStart"
                :disabled="loading"
                @selected="updateValue('memorandumPeriodStart', $event)"
            ></date>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Конец действия меморандума:"
              :invalid-feedback="errors.memorandumPeriodEnd"
              :state="states.memorandumPeriodEnd"
          >
            <date
                size="sm"
                :value="item.memorandumPeriodEnd"
                :state="states.memorandumPeriodEnd"
                :disabled="loading"
                @selected="updateValue('memorandumPeriodEnd', $event)"
            ></date>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
              label="Меморандум:"
              :invalid-feedback="errors.memorandumPath"
              :state="states.memorandumPath"
          >
            <b-row class="p-0">
              <b-col>
                <file-uploader
                    ref="fileUploader"
                    :accept="mimeTypes.join(',')"
                    :disabled="loading"
                    @change="uploadMemorandumFile($event)"
                ></file-uploader>
                <b-link target="_blank" v-if="item.memorandumPath" :href="item.memorandumUrl">{{ item.memorandumPath.split('/').slice(-1)[0] }}</b-link>
              </b-col>

              <b-col>
                <div
                    v-if="!item.memorandumPath && !$fileManager2.files[memorandumFileId]"
                    class="text-center"
                >
                </div>
                <div
                    v-if="!item.memorandumPath && $fileManager2.files[memorandumFileId]"
                    class="loader"
                >
                  <template v-if="!$fileManager2.files[memorandumFileId].error"><span class="mr-2">{{ $fileManager2.files[memorandumFileId].progress }}%</span> <b-spinner variant="primary"></b-spinner></template>
                  <template v-else>Ошибка при загрузке файла!</template>
                </div>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group
        label="Постер:"
        :invalid-feedback="errors.posterPath"
        :state="states.posterPath"
      >
        <b-row class="p-0">
          <b-col>
            <file-uploader
              ref="posterUploader"
              :disabled="loading"
              @change="uploadPoster($event)"
            ></file-uploader>
          </b-col>

          <b-col>
            <image-viewer
              v-if="item.posterUrl"
              :image="item.posterUrl"
              @remove="resetPoster()"
            ></image-viewer>
            <div
              v-if="!item.posterUrl && !$fileManager2.files[posterFileId]"
              class="text-center"
            >
              <img :src="noPhoto" class="w-50" />
            </div>
            <div
              v-if="!item.posterUrl && $fileManager2.files[posterFileId]"
              class="loader"
            >
              <template v-if="!$fileManager2.files[posterFileId].error"><span class="mr-2">{{ $fileManager2.files[posterFileId].progress }}%</span> <b-spinner variant="primary"></b-spinner></template>
              <template v-else>Ошибка при загрузке постера!</template>
            </div>
          </b-col>
        </b-row>
      </b-form-group>

      <b-form-group
        label="Анимированный постер:"
        :invalid-feedback="errors.animatedPosterPath"
        :state="states.animatedPosterPath"
      >
        <b-row class="p-0">
          <b-col>
            <file-uploader
              ref="animatedPosterUploader"
              accept="video/webm"
              :disabled="loading"
              @change="uploadAnimatedPoster($event)"
            ></file-uploader>
          </b-col>

          <b-col>
            <video-viewer
              v-if="item.animatedPosterUrl"
              :video="item.animatedPosterUrl"
              @remove="resetAnimatedPoster()"
            ></video-viewer>
            <div
              v-if="
                !item.animatedPosterUrl &&
                !$fileManager2.files[animatedPosterFileId]
              "
              class="text-center"
            >
              <img :src="noPhoto" class="w-50" />
            </div>
            <div
              v-if="
                !item.animatedPosterUrl &&
                $fileManager2.files[animatedPosterFileId]
              "
              class="loader"
            >
              <template
                v-if="!$fileManager2.files[animatedPosterFileId].error"
                ><span class="mr-2"
                  >{{
                  $fileManager2.files[animatedPosterFileId].progress
                  }}%</span
                >
                <b-spinner variant="primary"></b-spinner
              ></template>
              <template v-else>Ошибка при загрузке постера!</template>
            </div>
          </b-col>
        </b-row>
      </b-form-group>

      <b-form-group
        label="Трейлер:"
        :invalid-feedback="errors.trailerPath"
        :state="states.trailerPath"
      >
        <b-row class="p-0">
          <b-col>
            <file-uploader
              ref="trailerUploader"
              accept="video/*"
              :disabled="loading"
              :multiple="false"
              @change="uploadTrailer($event)"
            ></file-uploader>
          </b-col>

          <b-col>
            <video-viewer
              v-if="item.trailerUrl"
              :video="item.trailerUrl"
              @remove="resetTrailer()"
            ></video-viewer>
            <div
              v-if="!item.trailerUrl && !$fileManager2.files[trailerFileId]"
              class="text-center"
            >
              <img :src="noPhoto" class="w-50" />
            </div>
            <div
              v-if="!item.trailerUrl && $fileManager2.files[trailerFileId]"
              class="loader"
            >
              <template v-if="!$fileManager2.files[trailerFileId].error"><span class="mr-2">{{ $fileManager2.files[trailerFileId].progress }}%</span> <b-spinner variant="primary"></b-spinner></template>
              <template v-else>Ошибка при загрузке трейлера!</template>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
                label="Рейтинг IMDB:"
                :invalid-feedback="errors.imdbRating"
                :state="states.imdbRating"
            >
              <b-form-input
                  type="number"
                  size="sm"
                  :value="item.imdbRating"
                  :state="states.imdbRating"
                  :disabled="loading"
                  @change="updateValue('imdbRating', $event)"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
                label="Рейтинг Кинопоиск:"
                :invalid-feedback="errors.kinopoiskRating"
                :state="states.kinopoiskRating"
            >
              <b-form-input
                  type="number"
                  size="sm"
                  :value="item.kinopoiskRating"
                  :state="states.kinopoiskRating"
                  :disabled="loading"
                  @change="updateValue('kinopoiskRating', $event)"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form-group>

      <div class="border-bottom d-flex align-items-center justify-content-between pb-2 mb-3 mt-3">
        <div class="text-uppercase">Форматы</div>
        <b-button
          v-if="item.releases === undefined || (item.releases && item.releases.length !== formats.length)"
          size="sm"
          variant="outline-info"
          :disabled="loading"
          @click="addRelease()"
        >
          <icon icon="fa-plus"></icon> Добавить формат
        </b-button>
      </div>

      <div
        class="text-center"
        v-if="!item.releases || (!item.releases && !item.releases.length)"
      >Нет форматов</div>

      <div
        v-for="(release, index) in item.releases"
        :key="index"
        class="border-bottom items-container mb-4"
      >
        <b-row>
          <b-col>
            <b-form-group
              label="Формат:"
              :invalid-feedback="errors[`releases.${index}.formatId`]"
              :state="states[`releases.${index}.formatId`]"
            >
              <b-form-select
                size="sm"
                :value="release.formatId"
                :state="states[`releases.${index}.formatId`]"
                :disabled="release.id !== '' || loading"
                @change="updateRelease(index, { type: 'formatId', value: $event })"
              >
                <b-form-select-option
                  v-if="release.formatId"
                  :value="release.formatId"
                >{{ formatNameRelease(release.formatId) }}</b-form-select-option>
                <template v-for="(format, formatIndex) in formats">
                  <b-form-select-option
                    v-if="(release.id !== '' || filterRelease(format.id))"
                    :key="formatIndex"
                    :value="format.id"
                  >{{ format.name }}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Продолжительность:"
              :invalid-feedback="errors[`releases.${index}.duration`]"
              :state="states[`releases.${index}.duration`]"
            >
              <b-input-group size="sm" append="мин">
                <b-form-input
                  type="number"
                  :value="release.duration"
                  :state="states[`releases.${index}.duration`]"
                  :disabled="loading"
                  @change="updateRelease(index, { type: 'duration', value: $event })"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <span
          class="items-container__trash-button"
          :disabled="loading"
          @click="removeRelease(release.formatId)"
        >
          <icon icon="fa-times"></icon>
        </span>
      </div>
      <div class="border-bottom d-flex align-items-center justify-content-between pb-2 mb-3 mt-3">
        <div class="text-uppercase">Интегрированные трейлеры</div>
        <b-button
          size="sm"
          variant="outline-info"
          :disabled="loading"
          @click="addIntegratedTrailer()"
        >
          <icon icon="fa-plus"></icon> Добавить интегрированный трейлер
        </b-button>
      </div>

      <div
        class="text-center"
        v-if="!item.integratedTrailers || !item.integratedTrailers.length"
      >Нет интегрированных трейлеров</div>

      <div
        v-for="(integratedTrailer, index) in item.integratedTrailers"
        :key="index"
        class="border-bottom items-container mb-4"
      >
        <b-row>
        <b-col>
          <b-form-group
              label="Фильм:"
              :invalid-feedback="errors[`integratedTrailers.${index}.trailerMovieId`]"
              :state="states[`integratedTrailers.${index}.trailerMovieId`]"
          >
            <dictionary-provider name="movies">
              <template #default="{ items: movies, loading: moviesLoading }">
                <toggle-list
                  :options="movies"
                  :value="integratedTrailer.trailerMovieId ? [convertToValue(integratedTrailer.trailerMovieId, movies)] : []"
                  :searchable="true"
                  :disabled="loading || moviesLoading"
                  :multiple="false"
                  :close-on-select="true"
                  @change="updateTrailerMovieId(index, $event)"
                ></toggle-list>
              </template>
            </dictionary-provider>
          </b-form-group>
        </b-col>
          <b-col>
            <b-form-group
              label="Продолжительность:"
              :invalid-feedback="errors[`integratedTrailers.${index}.duration`]"
              :state="states[`integratedTrailers.${index}.duration`]"
            >
              <b-input-group size="sm" append="сек">
                <b-form-input
                  type="number"
                  :value="integratedTrailer.duration"
                  :state="states[`integratedTrailers.${index}.duration`]"
                  :disabled="loading"
                  @change="updateIntegratedTrailer(index, { type: 'duration', value: $event })"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <span
          class="items-container__trash-button"
          :disabled="loading"
          @click="removeIntegratedTrailer(integratedTrailer.trailerMovieId)"
        >
          <icon icon="fa-times"></icon>
        </span>
      </div>
      <b-row>
        <b-col>
          <b-form-group
              label="KPID:"
              :invalid-feedback="errors.kinopoiskId"
              :state="states.kinopoiskId"
          >
            <b-form-input
                type="text"
                size="sm"
                :value="item.kinopoiskId"
                :state="states.kinopoiskId"
                :disabled="loading"
                @change="updateValue('kinopoiskId', $event)"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="KP2ID:"
              :invalid-feedback="errors.kinoplanId"
              :state="states.kinoplanId"
          >
            <b-form-input
                type="text"
                size="sm"
                :value="item.kinoplanId"
                :state="states.kinoplanId"
                :disabled="loading"
                @change="updateValue('kinoplanId', $event)"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="MKRFID:"
              :invalid-feedback="errors.mkrfId"
              :state="states.mkrfId"
          >
            <b-form-input
                type="text"
                size="sm"
                :value="item.mkrfId"
                :state="states.mkrfId"
                :disabled="loading"
                @change="updateValue('mkrfId', $event)"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Удален:"
              :invalid-feedback="errors.deleted"
              :state="states.deleted"
          >
            <b-form-checkbox
                :checked="item.deleted"
                :state="states.deleted"
                :disabled="loading"
                @change="updateValue('deleted', !item.deleted)"
            >
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </b-tab>
</b-tabs>
</template>

<script>
import { mapState } from 'vuex';

import noPhoto from '../../assets/no_photo.png';

import DictionaryProvider from '../../providers/DictionaryProvider';
import {
  API_SERVER, API_PORT,
} from '../../config';
import Date from '../../components/fields/Date.vue';
import FileUploader from '../../components/fields/FileUploader.vue';
import ImageViewer from '../../components/ImageViewer.vue';
import VideoViewer from '../../components/VideoViewer.vue';
import ToggleList from '../../components/fields/ToggleList.vue';

export default {
  components: {
    Date,
    DictionaryProvider,
    FileUploader,
    ImageViewer,
    ToggleList,
    VideoViewer,
  },
  props: {
    loading: {
      default: false,
    },
    errors: {
      default: () => ({}),
    },
    states: {
      default: () => ({}),
    },
    item: {
      default: () => ({}),
    },
  },
  data() {
    return {
      mimeTypes: [
        'application/pdf', // pdf
        'application/vnd.ms-excel', // xls
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
        'application/msword', // doc
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
        'text/csv', // csv
      ],
      noPhoto,
      posterFileId: -1,
      animatedPosterFileId: -1,
      trailerFileId: -1,
      rentalLicenseFileId: -1,
      unfFileId: -1,
      memorandumFileId: -1,
    };
  },
  computed: {
    ...mapState('dictionaries/formats', {
      formats: (state) => state.items,
    }),

    noLaboratoryOption() {
      return {
        id: null,
        name: 'Нет доставки',
        code: '',
        isNoLaboratory: true
      };
    },

    allFormatReleases() {
      return this.item.releases && this.item.releases.map(({ formatId }) => formatId);
    },

    trailer() {
      return this.item.trailer?.file && `${API_SERVER + (API_PORT ? `:${API_PORT}` : '')}/${this.item.trailer.file.filepath}`;
    },
  },
  async created() {
    await this.$store.dispatch('dictionaries/formats/fetchItems');
  },
  methods: {
    removeRelease(formatId) {
      this.updateValue('releases', this.item.releases.filter((release) => release.formatId !== formatId));
    },

    addRelease() {
      let copy = [];
      if (this.item && this.item.releases) {
        copy = [...this.item.releases];
      }

      copy.push({ id: '' });

      this.updateValue('releases', copy);
    },

    filterRelease(formatId) {
      return !this.allFormatReleases.includes(formatId);
    },

    formatNameRelease(formatId) {
      return this.formats?.find((format) => format.id === formatId)?.name;
    },

    updateRelease(index, { type, value }) {
      const copy = [...this.item.releases];

      copy[index][type] = value;

      this.updateValue('releases', copy);
    },

    removeIntegratedTrailer(trailerMovieId) {
      this.updateValue('integratedTrailers', this.item.integratedTrailers.filter((integratedTrailer) => integratedTrailer.trailerMovieId !== trailerMovieId));
    },

    addIntegratedTrailer() {
      let copy = [];
      if (this.item && this.item.integratedTrailers) {
        copy = [...this.item.integratedTrailers];
      }

      copy.push({ trailerMovieId: '', duration: 0 });

      this.updateValue('integratedTrailers', copy);
    },

    updateIntegratedTrailer(index, { type, value }) {
      const copy = [...this.item.integratedTrailers];

      copy[index][type] = value;

      this.updateValue('integratedTrailers', copy);
    },

    updateTrailerMovieId(index, $event) {
      if (!$event || !$event.length) {
        return;
      }

      const movie = $event[$event.length - 1];

      const copy = [...this.item.integratedTrailers];

      copy[index].trailerMovieId = movie.id;

      this.updateValue('integratedTrailers', copy);
    },

    async uploadPoster(files) {
      this.updateValue('posterPath', '');
      this.updateValue('posterUrl', '');

      this.$fileManager2.upload(files[0]).then((data) => {
        this.$refs.posterUploader.reset();

        if (!data) {
          return;
        }

        this.updateValue('posterPath', data.path);
        this.updateValue('posterUrl', data.url);

        this.posterFileId = -1;
      });

      this.posterFileId = this.$fileManager2.getFileIndex(files[0]);
    },

    resetPoster() {
      this.updateValue('posterPath', '');
      this.updateValue('posterUrl', '');

      this.$refs.posterUploader.reset();
      this.posterFileId = -1;
    },

    async uploadAnimatedPoster(files) {
      this.updateValue('animatedPosterPath', '');
      this.updateValue('animatedPosterUrl', '');

      this.$fileManager2.upload(files[0]).then(data => {
        this.$refs.animatedPosterUploader.reset();

        if (!data) {
          return;
        }

        this.updateValue('animatedPosterPath', data.path);
        this.updateValue('animatedPosterUrl', data.url);

        this.animatedPosterFileId = -1;
      });

      this.animatedPosterFileId = this.$fileManager2.getFileIndex(files[0]);
    },

    resetAnimatedPoster() {
      this.updateValue('animatedPosterPath', '');
      this.updateValue('animatedPosterUrl', '');

      this.$refs.animatedPosterUploader.reset();
      this.animatedPosterFileId = -1;
    },

    async uploadTrailer(files) {
      this.updateValue('trailerPath', '');
      this.updateValue('trailerUrl', '');

      this.$fileManager2.upload(files[0]).then((data) => {
        this.$refs.trailerUploader.reset();

        if (!data) {
          return;
        }

        this.updateValue('trailerPath', data.path);
        this.updateValue('trailerUrl', data.url);

        this.trailerFileId = -1;
      });

      this.trailerFileId = this.$fileManager2.getFileIndex(files[0]);
    },

    resetTrailer() {
      this.updateValue('trailerPath', '');
      this.updateValue('trailerUrl', '');

      this.$refs.trailerUploader.reset();
      this.trailerFileId = -1;
    },
    async uploadRentalLicenseFile(files) {
      this.updateValue('rentalLicensePath', '');

      this.$fileManager2.upload(files[0]).then((data) => {
        if (!data) {
          return;
        }

        this.updateValue('rentalLicensePath', data.path);

        this.rentalLicenseFileId = -1;
      });

      this.rentalLicenseFileId = this.$fileManager2.getFileIndex(files[0]);
    },
    async uploadUnfFile(files) {
      this.updateValue('unfPath', '');

      this.$fileManager2.upload(files[0]).then((data) => {
        if (!data) {
          return;
        }

        this.updateValue('unfPath', data.path);

        this.unfFileId = -1;
      });

      this.unfFileId = this.$fileManager2.getFileIndex(files[0]);
    },
    async uploadMemorandumFile(files) {
      this.updateValue('memorandumPath', '');

      this.$fileManager2.upload(files[0]).then((data) => {
        if (!data) {
          return;
        }

        this.updateValue('memorandumPath', data.path);

        this.memorandumFileId = -1;
      });

      this.memorandumFileId = this.$fileManager2.getFileIndex(files[0]);
    },

    convertToValue(id, options) {
      if (!id) {
        return [];
      }

      return options.find((option) => (id === option.id));
    },

    updateDistributorId($event) {
      if (!$event || !$event.length) {
        return;
      }

      const distributor = $event[$event.length - 1];
      this.updateValue('distributorId', distributor.id);
    },

    updateLaboratoryId($event) {
      if (!$event || !$event.length) {
        this.clearLaboratory();
        return;
      }

      const laboratory = $event[$event.length - 1];
      
      if (laboratory.isNoLaboratory) {
        this.clearLaboratory();
        return;
      }
      
      this.updateValue('laboratoryId', laboratory.id);
      this.updateValue('laboratoryKey', laboratory.code);
      this.$set(this.item, 'laboratory', laboratory);
    },

    clearLaboratory() {
      this.updateValue('laboratoryId', null);
      this.updateValue('laboratoryKey', null);
      this.$set(this.item, 'laboratory', null);
    },

    laboratoriesWithDisplayName(laboratories) {
      const formattedLaboratories = laboratories.map(lab => ({
        ...lab,
        name: `${lab.name} (${lab.code})`.trim()
      }));
      
      return [this.noLaboratoryOption, ...formattedLaboratories];
    },

    getCurrentLaboratoryValue(laboratories) {
      if (!this.item.laboratoryId) {
        return [this.noLaboratoryOption];
      }
      
      if (!laboratories.length) {
        return [];
      }
      
      const currentLab = laboratories.find(lab => lab.id === this.item.laboratoryId);
      
      if (currentLab) {
        return [{
          ...currentLab,
          name: `${currentLab.name} (${currentLab.code})`.trim()
        }];
      }
      
      return [];
    },

    updateValue(field, value) {
      this.$emit('change', {
        field,
        value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .card-header {
  background-color: inherit;
  padding-top: 0;
}
.items-container {
  position: relative;

  &__trash-button {
    position: absolute;
    right: 0;
    top: -4px;
    color: #AA0000;
    cursor: pointer;
  }
}
video {
  width: 100%;
  height: 100%;
  display: block;
}
.loader {
  background-color: #fff;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
</style>
